module.exports = __webpack_public_path__ + "static/jenkins-c529ff89bf3007af697ed01329ab6f70.svg";